<template>
  <input
    id="file-input"
    class="hide-file-input"
    type="file"
    accept="image/*"
    @change="onFileChange($event)"
  />
</template>
<script>
const action = {
  valdateImage(file, allowedTypes, callbackMessage) {
    if (!allowedTypes) {
      allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "application/pdf",
      ];
    }

    if (!file) {
      return callbackMessage("Please select an image file");
    } else if (!allowedTypes.includes(file.type)) {
      let typeAllow = "";
      for (let i = 0; i < allowedTypes.length; i++) {
        let tmp = allowedTypes[i].split("/");
        typeAllow += tmp[tmp.length - 1];

        if (i < allowedTypes.length - 2) {
          typeAllow += ", ";
        } else if (i == allowedTypes.length - 2) {
          typeAllow += " and ";
        }
      }

      return callbackMessage("Invalid file type. Only {typeAllow} are allowed.",{typeAllow:typeAllow});
    } else if (file.size > 4000000) {
      return callbackMessage('File size too large. Maximum size is 4MB.');
    } else {
      return "";
    }
  },
};

export default {
  props: ["allowedTypes"],
  methods: {
    getMessage(message,params){
      if(params){
        return this.$t(message,params);
      }
      else{
        return this.$t(message);
      }
    },
    onFileChange($event) {
      const file = $event.target.files[0];
      const reader = new FileReader();
      const validate = action.valdateImage(file, this.allowedTypes, this.getMessage);
      if (validate == "") {
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set a new property on the captured `file` and set it to the converted base64 image
          file.previewBase64 = reader.result;
          // Emit the file with the new previewBase64 property on it
          this.$emit("file-updated", file);
        };
        reader.onerror = (error) => {};
      } else {
        this.$notify({
          type: "warn",
          text: validate,
        });
      }
    },
  },
};
</script>
